import moment from "moment";
import { createSelector } from "reselect";
import { isEqual } from "lodash";
import { initialState } from "./reducers";
import { selectCommunityData } from "store/community/selectors";

export const selectUpgrades = ({ commUpgrades = initialState }) => commUpgrades;

export const selectCapitalCosts = createSelector([selectUpgrades], ({ capitalCosts }) => capitalCosts);

export const selectCommBaseModelId = createSelector([selectUpgrades], ({ baseModelId }) => baseModelId);

export const selectIsCommUpgradesSaving = createSelector([selectUpgrades], ({ isSavingUpgrades }) => isSavingUpgrades);

// Determine whether changes have been made to the packages, compare current packages to initial state
export const selectIsCommUpgradesChanged = createSelector(
    [selectUpgrades],
    ({ packages = {}, initPackages = {} }) => !isEqual(packages, initPackages)
);

// Return the current packages displayed on screen
export const selectCommUpgradePackages = createSelector(
    [selectUpgrades, selectCommunityData],
    ({ packages = {} }, { modelDir = {} }) => packages
);

// TODO: implement sorting
// For sorting
// - Need to update sort in redux when it changes and therefore it should update everything on save
// - 1. On create - DONE
// - 2. On delete - DONE
// - 3. On sort change
// ...anything else?

//
export const selectUpgradePackagesSortedArray = createSelector([selectCommUpgradePackages], (packages) =>
    Object.keys(packages)
        .filter((packageId) => packageId !== "base")
        .map((packageId) => ({
            ...packages[packageId],
            id: packageId,
        }))
        .sort(upgradePackageSort)
);

export const selectBaseUiDetails = createSelector(
    [selectCommUpgradePackages],
    (packages) =>
        Object.keys(packages)
            .filter((packageId) => packageId === "base")
            .map((packageId) => ({
                id: packageId,
                ...packages[packageId],
            }))[0]
);

export const selectUpgradePackagesIds = createSelector([selectCommUpgradePackages], (packages) =>
    Object.keys(packages).filter((packageId) => packageId !== "base")
);

export const upgradePackageSort = (a, b) => {
    const { created: createdA, ui: { displayOrder: orderA = 0 } = {} } = a;
    const { created: createdB, ui: { displayOrder: orderB = 0 } = {} } = b;

    if (orderB !== orderA) {
        return orderB > orderA ? -1 : 1;
    }

    if (moment(createdB) > moment(createdA)) {
        return 1;
    }
    if (moment(createdB) < moment(createdA)) {
        return -1;
    }
    return 0;
};

export const selectSavedUpgradePackages = createSelector([selectUpgrades], (packages) => packages.savedUpgradePackages);
